
import { getAll } from "../utilities/querySelector";
import { mouseFollowWhenVisible } from "../utilities/mouse-follow";

getAll( '[data-big-banner]' ).forEach( mouseFollowWhenVisible );